import React, { ChangeEvent, Component } from 'react';
import { ColumnProps } from 'primereact/column';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import { ApiVariableParameter } from '../../../../../domain/remote/httpVariable/HttpVariableDomains';
import CustomInput from '../../../../custom/CustomInput';
import RoleHelper from '../../../../../RoleHelper';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionApiVariableParameter, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import Icon from '../../../../../icons/Icon';
import CustomCheckBox from '../../../../custom/CustomCheckBox';
import CustomTable from '../../../../custom/CustomTable';
import EmptyListComponent from '../../../../custom/empty-components/EmptyListComponent';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiParametersListComponent extends Component<Props> {
  public render() {
    const {
      action: { action },
    } = this.props;
    if ((action as ApiActionJsonModel)?.parameters?.length == 0 || (action as ApiActionJsonModel).parameters == undefined) return <EmptyListComponent />;
    return (
      <div className={'overflow-y-hidden lg:!max-h-[calc(100vh-28.625rem)] rounded-lg'}>
        <CustomTable columns={this.getColumns()} value={(action as ApiActionJsonModel).parameters} />
      </div>
    );
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'isActive',
        header: LanguageUtil.get({ id: 'components.action.api.parameters.table.active', defaultMessage: 'Active' }),
        headerClassName: '',
        className: 'max-w-[10%]',
        body: (variableParameter: ApiVariableParameter) => (
          <div className={'flex items-center justify-center w-full h-full'}>
            <CustomCheckBox
              size={'small'}
              onChangeChecked={(checked, e) => this.onChangeActive(checked, variableParameter)}
              checked={variableParameter.isActive}
            />
          </div>
        ),
      },
      {
        field: 'key',
        header: LanguageUtil.get({ id: 'components.action.api.parameters.table.key', defaultMessage: 'Key' }),
        className: 'min-w-[30%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeKey(e, variableParameter)}
            value={variableParameter.key}
            data-testid={`${ComponentName.ACTION}_parameter_key_input_${variableParameter.key}`}
          />
        ),
      },
      {
        field: 'value',
        header: LanguageUtil.get({ id: 'components.action.api.parameters.table.value', defaultMessage: 'Value' }),
        className: 'min-w-[25%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeValue(e, variableParameter)}
            value={variableParameter.value}
            data-testid={`${ComponentName.ACTION}_parameter_value_input_${variableParameter.key}`}
          />
        ),
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'components.action.api.parameters.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[28%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeDescription(e, variableParameter)}
            value={variableParameter.description}
            data-testid={`${ComponentName.ACTION}_parameter_description_input_${variableParameter.key}`}
          />
        ),
      },
      {
        field: 'action',
        className:'max-w-[100px]',
        alignHeader: 'center',
        header: LanguageUtil.get({ id: 'components.action.api.parameters.table.action', defaultMessage: 'Action' }),
        sortable: false,
        body: (variableParameter: ApiVariableParameter) => (
          <div
            className={'flex items-center justify-center'}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              RoleHelper.canEdit('Action') &&
                customConfirm({
                  target: e.currentTarget,
                  accept: () => this.deleteApiVariableParameter(variableParameter),
                  message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                });
            }}
            data-testid={`${ComponentName.ACTION}_api_parameters_list_${variableParameter.key}_remove_button`}
          >
            <Icon icon={'delete'} size={20} className={'hover:text-primary text-primary hover:cursor-pointer flex items-center justify-center'} />
          </div>
        ),
      },
    ];
  };

  private onChangeActive = (checked: boolean, variableParameter: ApiVariableParameter) => {
    const {
      action: { action },
      changeAction,
      changeActionApiVariableParameter,
    } = this.props;
    variableParameter.isActive = checked;
    changeActionApiVariableParameter(action);
    changeAction(action);
  };

  private onChangeKey = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      action: { action },
      changeAction,
      changeActionApiVariableParameter,
    } = this.props;
    variableParameter.key = e.currentTarget.value;
    changeActionApiVariableParameter(action);
    changeAction(action);
  };

  private onChangeValue = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      action: { action },
      changeAction,
      changeActionApiVariableParameter,
    } = this.props;
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    let variables = (action as ApiActionJsonModel).url.split(regex);
    variables = variables.filter((item) => item != '');
    variables.shift();
    variableParameter.value = e.currentTarget.value;
    changeActionApiVariableParameter(action);
    changeAction(action);
  };

  private onChangeDescription = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
    variableParameter.description = e.currentTarget.value;
    changeAction(action);
  };

  private deleteApiVariableParameter = (parameter: ApiVariableParameter) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
    (action as ApiActionJsonModel).parameters = (action as ApiActionJsonModel).parameters.filter((p: ApiVariableParameter) => p.key != parameter.key);
    changeAction(action);
  };
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,
  changeActionApiVariableParameter,
  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ApiParametersListComponent));
